import { systemCode, xs_languageCode } from "..";

export function parseAdditionalData(data) {
    if (data == null || data === 'null') {
        return null;
    }

    let result = null;
    let parsedData = JSON.parse(data);
    if (parsedData != null) {
        parsedData = parsedData[systemCode] || parsedData['DEFAULT'];
    }

    if (parsedData != null) {
        result = parsedData.messages?.[0]?.[xs_languageCode]?.trim() ?? null;
    }
    return result;
}
